import { observable } from 'mobx';

export type AirRouteDetailResponseArgs = {
  cancel_policies: string[];
  change_reservation_policies: string[];
};

export type AirRouteDetailArgs = {
  cancelPolicies: string[];
  changeReservationPolicies: string[];
};

export const convertAirRouteDetailResponseToArgs = (response: AirRouteDetailResponseArgs) => {
  const args: AirRouteDetailArgs = {
    cancelPolicies: response.cancel_policies,
    changeReservationPolicies: response.change_reservation_policies
  };
  return args;
};

export default class AirRouteDetail {
  @observable cancelPolicies: string[];
  @observable changeReservationPolicies: string[];

  constructor(args: AirRouteDetailArgs) {
    this.cancelPolicies = args.cancelPolicies;
    this.changeReservationPolicies = args.changeReservationPolicies;
  }
}
